import React, {useEffect, useState} from "react";
import "../../styles/App.css";
import {useTranslation} from "react-i18next";
import DialogCloseButton from "../buttons/DialogCloseButton";
import LoginForm from "../forms/login/LoginForm";
import RegisterForm from "../forms/login/RegisterForm";
import MessageBox, {MessageType} from "../components/MessageBox";

interface LoginDialogProps {
    open: boolean;
    onClose: () => void;
}

function LoginDialog({
                         open,
                         onClose,
                     }: LoginDialogProps) {
    const {t} = useTranslation();

    const [tab, setTab] = useState<"login" | "register">("login");
    const [message, setMessage] = useState<MessageType>(null);

    useEffect(() => {
        if (open) {
            setTab("login");
            setMessage(null);
        }
    }, [open]);

    if (!open) return null;

    return (
        <div className="dialog-overlay">
            <div className="dialog">
                <DialogCloseButton
                    onClose={() => {
                        setMessage(null);
                        onClose();
                    }}
                />

                <div className="auth-tabs">
                    <button
                        className={`auth-tab ${tab === "login" ? "active" : ""}`}
                        onClick={() => setTab("login")}
                    >
                        {t("auth.actions.login")}
                    </button>
                    <button
                        className={`auth-tab ${tab === "register" ? "active" : ""}`}
                        onClick={() => setTab("register")}
                    >
                        {t("auth.actions.register")}
                    </button>
                </div>

                <MessageBox message={message}/>

                {tab === "login" && (
                    <LoginForm
                        setMessage={setMessage}
                        onSuccess={() => {
                            setMessage(null);
                            onClose();
                        }}
                    />
                )}

                {tab === "register" && (
                    <RegisterForm
                        setMessage={setMessage}
                        switchToLogin={() => setTab("login")}
                    />
                )}
            </div>
        </div>
    );
}

export default LoginDialog;